import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/contexts/CartContext";
const FloatingCart = lazy(() => import("@/components/cart/FloatingCart").then(m => ({ default: m.FloatingCart })));
import DynamicCanonical from "@/components/DynamicCanonical";
import Index from "./pages/Index";

const QuestionnairePage = lazy(() => import("./pages/QuestionnairePage"));
const PolitiquePage = lazy(() => import("./pages/PolitiquePage"));
const DonneesPage = lazy(() => import("./pages/DonneesPage"));
const PartenairePage = lazy(() => import("./pages/PartenairePage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const BlogAdminPage = lazy(() => import("./pages/BlogAdminPage"));
const ProductPage = lazy(() => import("./pages/ProductPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <CartProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <DynamicCanonical />
          <Suspense fallback={null}><FloatingCart /></Suspense>
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/questionnaire" element={<QuestionnairePage />} />
              <Route path="/politique" element={<PolitiquePage />} />
              <Route path="/donnees" element={<DonneesPage />} />
              <Route path="/partenaire" element={<PartenairePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/blog-admin" element={<BlogAdminPage />} />
              <Route path="/produit/:id" element={<ProductPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </CartProvider>
  </QueryClientProvider>
);

export default App;
